import { Pipe, PipeTransform } from '@angular/core';
import find from 'lodash-es/find';
@Pipe({
  name: 'getDataById',
  pure: true,
})
export class GetDataByIdPipe implements PipeTransform {
  transform = (data: any, id: string): any[] => find(data, i => i.id === id);
}
